module.exports = __webpack_public_path__ + "high-performance.11sNLjOe.svg";